<template>
  <div>
    <navBar />
    <div class="main main-container">
      <div class="banner">
        <img src="@/assets/images/caseCar/banner.png" />
        <div class="banner-title">企业微信应用</div>
      </div>
      <div class="wrap-nav">
        <img src="@/assets/images/weChat/bs.jpg" class="big-img-one" v-if="showIndex">
        <img src="@/assets/images/weChat/bg2.jpg" class="big-img-two" v-else>
        <div class="container">
          <div class="wrap-nav-describe">
            基于企业微信生态，根据品牌行业特性，我们提供3种不同的产品，分别支持零售门店运营，销售管理与社群运营。
          </div>
          <el-tabs v-model="titleStyle" @tab-click="clickTitle">
            <el-tab-pane label="零售导购赋能" name="0">
              <div class="content-box">
                <div class="describe" style="align-items: flex-start;margin-top:65px">
                  <img src="@/assets/images/weChat/management.png" />
                  <div class="describe-box" style="padding-top: 63px">
                    <p>门店与账号管理</p>
                    <p>
                      基于零售线下业态，将实体门店与导购账号进行有效关联，建立门店，导购，客户三方数据关系，优化后期营销与管理效率。
                    </p>
                  </div>
                </div>

                <div class="describe">
                  <div class="describe-box"  style="margin-top: -100px" >
                    <p>会员管理与自动化任务</p>
                    <p>
                     将会员分配给一线导购，可以通过系统及时查看客户数据，同时通过会员生命周期创建各类回访与营销任务，精准到人，提高营销内容触达率与转化率。
                    </p>
                  </div>
                  <img src="@/assets/images/weChat/member.png" />
                </div>

                <div class="describe">
                  <img src="@/assets/images/weChat/ShoppersData.png" style="margin-top: 35px; margin-left: 100px"/>
                  <div class="describe-box" style="margin-left: 152px">
                    <p>导购数据管理</p>
                    <p>
                      导购可以基于个人权限查看所属会员、门店、销售、产品等多类数据，真正做到业务心中有数，提高运营效率。
                    </p>
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="销售管理" name="1">
               <div class="content-box2">
                <div class="describe-two">
                  <img  src="@/assets/images/weChat/marketing.png" style="width: 726px;height:226px"/>
                  <div class="describe-three-content">
                    <p>销售线索分配管理</p>
                    <p>
                      可根据线索来源，线索描述，线索类型，线索指定等多种机制对于销售线索实现自动化分配，提高线索流转效率与转化率。
                    </p>
                  </div>
                </div>

                <div class="describe-two">
                  <div class="describe-three-content2">
                    <p>销售过程管理</p>
                    <p>
                      分配后的线索可以建立跟进过程管理，要求销售在指定时间内进行跟进与信息完善，并确定下一步跟进模式与计划。
                    </p>
                  </div>
                  <img src="@/assets/images/weChat/marketingTo.png" style="margin-top:260px;width: 729px;height:226px"/>
                </div>
              </div>


            </el-tab-pane>
            <el-tab-pane label="社群运营" name="2">
              <div class="content-box3">
                <div class="describe-three">
                  <img  src="@/assets/images/weChat/association.png" />
                  <div class="describe-three-content">
                    <p>群用户与任务</p>
                    <p>
                      群管理可帮助品牌进行群聊赋能。从品牌管理侧、会员管理侧双向发力。如：消息群发，提高信息触达效率；入群自动发送欢迎语，提升服务质量；自动回复，为员工减负，给客户更好的服务；满人自动创建新群，无缝隙衔接，提高群聊管理效率。 </p>
                    <p class="content-p"> 群任务系统提醒客户所分配的品牌顾问当天收到相应任务，通过品牌推荐的话术，完成客户日常沟通，营销活动邀请，促成客户的复购，帮助维护并提升品牌客户关系。 </p>
                    
                  </div>
                </div>

                <div class="describe-three">
                  <div class="describe-three-content2">
                    <p>群数据管理</p>
                    <p>
                      配置相关群应用后，进入后台，在客户群列表中，不仅可以看到最终的数据，以及每个成员所有客户群的总数据，也可以看到企业每日的新增客户数、流失客户数以及今日入群、今日退群人数，并且在后台的客户列表与客户群列表中，还有更加详细的客户数据。
                    </p>
                  </div>
                  <img src="@/assets/images/weChat/associationTo.png" style="margin-top:133px"/>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
    <footerBar />
  </div>
</template>
<script>
import navBar from "@/components/nav-bar";
import footerBar from "@/components/footer-bar";
export default {
  data() {
    return {
      titleStyle: "0",
      titleList: ["零售导购赋能", "销售管理", "社群运营"],
      showIndex: true,
    };
  },
  components: {
    navBar,
    footerBar
  },
  created() {
   
  },

  mounted() {
    $(".el-tabs__active-bar").css("left", "-5px")
  },

  methods: {
    clickTitle(a) {
      this.titleStyle = a.name;
      if(this.titleStyle === "0") {
        $(".main").css("height", "3025px")
        this.showIndex = true;
        $(".el-tabs__active-bar").css("left", "-5px")
      } else {
        $(".main").css("height", "2300px")
        this.showIndex = false;
        $(".el-tabs__active-bar").css("left", "-25px")
      }
    },
  },
};
</script>
<style  lang="scss" scoped>
.main {
  max-width: 1920px;
  margin: 0 auto;
  font-family: Source Han Sans CN;
  // height: 2500px;
  min-width: $min-screen-width;
  height: 3025px;

  .banner {
    position: relative;
    height: 430px;
    overflow: hidden;
    z-index: 5;
    &-title {
      font-size: 40px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      // line-height: 68px;
      color: #FFFFFF;
      position: absolute;
      top: 208px;
      left: 565px;
    }
  }

  .wrap-nav {
    margin: 0 auto;
    margin-top: 105px;
    position: relative;

    .wrap-nav-describe {
      margin-top: 110px;
      padding-bottom: 80px;
      width: 1200px;
      margin: 0 auto;
      font-size: $font-size-20;
      line-height: 32px;
      text-align: center;
      color: #707070;
    }

    .content-box {
      .describe {
        display: flex;
        align-items: center;
      }

      .describe-box {
        padding-left: 60px;
      }
    }

    .content-box img:nth-child(2) {
      margin-left: 312px;
      margin-top: 205px;
    }

    .content-box2 {
      .describe-two {
        display: flex;
        //  justify-content: center;
        margin-top: 180px;
        .describe-three-content {
          margin-left:60px;
        }
        .describe-three-content2 {
          margin-left: 60px;
          margin-right: 60px;
          margin-top: 280px;
        }
      }
    }

    .content-box3 {
      .describe-three {
        display: flex;
        //  justify-content: center;
        margin-top: -30px;
        .describe-three-content {
          margin-left: 60px;
          margin-top: 160px;
        }
        .describe-three-content2 {
          margin-left: 60px;
          margin-right: 80px;
          margin-top: 260px;
        }
      }
    }

    p:nth-child(1) {
      font-size: $font-size-20;
      font-weight: bold;
      line-height: 50px;
      color: #464646;
    }
    p:nth-child(2) {
      margin-top: 30px;
      width: 360px;
      height: 87px;
      font-size: $font-size-18;
      font-family: SourceHanSansCN-Normal;
      line-height: 28px;
      color: #707070;
    }

     .content-p {
      margin-top: 130px;
      width: 360px;
      height: 87px;
      font-size: $font-size-18;
      font-family: SourceHanSansCN-Normal;
      line-height: 28px;
      color: #707070;
    }

  }
}

/deep/ .el-tabs__item {
  padding: 0 145px !important;
  font-size: $font-size-22;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #464646;
  line-height: 30px;
}

/deep/ .el-tabs__nav-wrap {
  margin-bottom: 65px;
}

/deep/ .el-tabs__active-bar {
  bottom: 0;
  left: -17px;
  width: 140px !important;
}

/deep/ .el-tabs__item.is-active {
  color: #409EFF !important;
}

.container {
  width: 1200px;
  margin: 0 auto;
  // height: 3525px;
  position: relative;
}
.big-img-one {
  position: absolute;
  top: -150px;
}
.big-img-two {
  position: absolute;
  top: -150px;
}
</style>


// WEBPACK FOOTER //
// src/view/weChat/index.vue